export function getOfferSaleMultiplierLabel(multiplier: number) {
  return `${multiplier}x BOOST`;
}
